import * as core from '../../../../../../../core'

import { query } from './subaward-details-info.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subaward-details.widgets.info',
    description: 'Subaward Details',
    name: 'Subaward Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
